<template>
  <div class="content-wrapper">
    <div class="content-title">订单付款</div>
    <div class="section">
      <div class="section-title">订单信息</div>
      <div v-loading="loading" class="section-content">
        <el-form :model="orderInfo.baseInfo" label-width="100px" class="order-form">
          <el-form-item label="订单号">
            <span>{{ orderInfo.baseInfo.orderNumber }}</span>
            <span class="view-order-detail">
              <router-link v-if="orderNumber" :to="{ name: 'order-info', params: { 'orderNumber': orderNumber }}" class="link-blue" target="_blank" rel="opener">查看订单详情</router-link>
            </span>
          </el-form-item>
          <el-form-item label="订单状态">
            <span>{{ orderInfo.baseInfo.orderStatusName }}</span>
          </el-form-item>
          <el-form-item :label="orderInfo.baseInfo.isPreOrder ? (orderInfo.baseInfo.orderStatus === 50 ? '定金金额' : '尾款金额') : '订单金额'">
            <span class="order-amount">￥ {{ (orderInfo.baseInfo.isPreOrder ? (orderInfo.baseInfo.orderStatus === 50 ? orderInfo.baseInfo.earnestAmount || 0 : orderInfo.baseInfo.orderAmount || 0) : orderInfo.baseInfo.orderAmount || 0 ) | toThousandslsFilter }} 元</span>
          </el-form-item>
          <el-form-item label="付款方式">
            <span>{{ orderInfo.baseInfo.payTypeName }}</span>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-if="needOnlinePay" class="section">
      <div class="section-title">选择支付方式</div>
      <div class="section-content">
        <div style="display: flex;">
          <div :class="{selected: payChannel === 'chinaumspayc2b'}" class="pay-channel" @click="selectPayChannel('chinaumspayc2b')">
            <img src="../../assets/images/chinaumspay.png">
            <div class="pay-channel-title">聚合支付</div>
            <div class="pay-channel-tips">支持微信/支付宝/云闪付多种支付方式</div>
          </div>
          <!-- <div :class="{selected: payChannel === 'alipay'}" class="pay-channel" @click="selectPayChannel('alipay')">
            <img src="../../assets/images/alipay.png">
            <div class="pay-channel-title">支付宝</div>
          </div>
          <div :class="{selected: payChannel === 'wxpay'}" class="pay-channel" @click="selectPayChannel('wxpay')">
            <img src="../../assets/images/wxpay.png">
            <div class="pay-channel-title">微信支付</div>
          </div> -->
          <div :class="{selected: payChannel === 'chinapayb2c'}" class="pay-channel" @click="selectPayChannel('chinapayb2c')">
            <img src="../../assets/images/chinapay.png">
            <div class="pay-channel-title">网银支付 - 对私</div>
          </div>
          <div :class="{selected: payChannel === 'chinapayb2b'}" class="pay-channel" @click="selectPayChannel('chinapayb2b')">
            <img src="../../assets/images/chinapay.png">
            <div class="pay-channel-title">网银支付 - 对公</div>
          </div>
        </div>
        <div class="button-line">
          <el-button :loading="submitLoading" class="large-button" @click="presetPayment">立 即 支 付</el-button>
        </div>
      </div>
    </div>

    <div v-if="needOfflinePay" class="section">
      <div class="section-title">银行转账付款信息</div>
      <div class="section-content">
        <el-form label-width="100px" class="order-form">
          <el-form-item label="开户行">平安银行上海自贸试验区分行营业部</el-form-item>
          <el-form-item label="公司名称">上海精程后勤服务有限公司</el-form-item>
          <el-form-item label="银行账户">15000097631173</el-form-item>
          <el-form-item label="备注">请在付款备注中注明 <b>订单号 {{ orderNumber }}</b> 以便客服审核订单。</el-form-item>
        </el-form>
      </div>
      <div class="button-line">
        <el-button type="default" class="btn-yellow" @click="toMyOrder">点击返回我的订单</el-button>
      </div>
    </div>

    <div v-if="orderPaid && preOrderPaid && finalPaid" class="section">
      <div class="button-line">
        <el-button v-if="orderPaid" type="default" class="btn-yellow" @click="toMyOrder">订单已支付，点击返回我的订单。</el-button>
        <el-button v-if="preOrderPaid" type="default" class="btn-yellow" @click="toMyOrder">定金已支付，点击返回我的订单。</el-button>
        <el-button v-if="finalPaid" type="default" class="btn-yellow" @click="toMyOrder">尾款已支付，点击返回我的订单。</el-button>
      </div>


    </div>

    <AlipayForm ref="alipay-form" />
    <WxpayDialog ref="wxpay-dialog" :order-number="orderNumber" :order-status="orderInfo.baseInfo.orderStatus" />
    <ChinapayForm ref="chinapay-form" />
    <ChinaumspayDialog ref="chinaumspay-dialog" :order-number="orderNumber" :order-status="orderInfo.baseInfo.orderStatus" />
  </div>
</template>

<script>
import orderApi from '@/api/order'
import AlipayForm from './components/alipay-form'
import WxpayDialog from './components/wxpay-dialog'
import ChinapayForm from './components/chinapay-form'
import ChinaumspayDialog from "@/views/order/components/chinaumspay-dialog.vue";
export default {
  name: 'OrderPayment',
  components: {
    AlipayForm,
    WxpayDialog,
    ChinapayForm,
    ChinaumspayDialog
  },
  data() {
    return {
      orderNumber: '',
      payChannel: '',
      orderInfo: {
        baseInfo: {},
        orderRecvInfo: {},
        detailList: []
      },
      loading: false,
      submitLoading: false
    }
  },
  computed: {

    needOnlinePay() {
      return (this.orderInfo.baseInfo.orderStatus === 100 || this.orderInfo.baseInfo.orderStatus === 50) && this.orderInfo.baseInfo.payType === '01'
    },
    needOfflinePay() {
      return (this.orderInfo.baseInfo.orderStatus === 100 || this.orderInfo.baseInfo.orderStatus === 50) && this.orderInfo.baseInfo.payType !== '01'
    },
    orderPaid() {
      return !this.orderInfo.baseInfo.isPreOrder && this.orderInfo.baseInfo.orderStatus !== 100
    },
    preOrderPaid() {
      return this.orderInfo.baseInfo.isPreOrder && this.orderInfo.baseInfo.orderStatus !== 50
    },
    finalPaid() {
      return this.orderInfo.baseInfo.isPreOrder && this.orderInfo.baseInfo.orderStatus !== 100
    }
  },

  mounted() {
    this.getOrderInfo()
  },
  methods: {
    getOrderInfo() {
      this.orderNumber = this.$route.params.orderNumber
      if (!this.orderNumber) {
        this.$router.push('/home')
        return
      }
      this.loading = true
      orderApi.queryOrderInfoByNumber(this.orderNumber).then(response => {
        this.loading = false
        if (response.data.resultCode === '0') {
          const orderInfo = response.data.resultData.orderInfo
          if (orderInfo) {
            this.orderInfo = Object.assign(this.orderInfo, orderInfo)
            this.payChannel = this.orderInfo.baseInfo.payChannel || ''
          } else {
            this.$message.error('订单信息异常')
            this.$router.push('/home')
          }
        } else {
          this.$router.push('/home')
        }
      }).catch(() => {
        this.loading = false
        this.$router.push('/home')
      })
    },
    selectPayChannel(channel) {
      this.payChannel = channel
    },
    presetPayment() {
      const payData = {
        orderNumber: this.orderNumber,
        payChannel: this.payChannel
      }
      this.submitLoading = true
      orderApi.presetPayment(payData).then(response => {
        this.submitLoading = false
        if (response.data.resultCode === '0') {
          const payUrl = response.data.resultData.payUrl
          if (!payUrl) {
            this.$message.error('支付接口请求发生错误')
            return false
          }
          if (this.payChannel === 'wxpay') {
            this.$refs['wxpay-dialog'].show(payUrl)
          }
          if (this.payChannel === 'chinaumspayc2b') {
            this.$refs['chinaumspay-dialog'].show(payUrl)
          }
          if (this.payChannel === 'alipay') {
            const payParams = response.data.resultData.paraMap
            this.$refs['alipay-form'].submitPay(payUrl, payParams)
          }
          if (this.payChannel === 'chinapayb2c' || this.payChannel === 'chinapayb2b') {
            const payParams = response.data.resultData.paraMap
            this.$refs['chinapay-form'].submitPay(payUrl, payParams)
          }
        }
      }).catch(() => {
        this.submitLoading = false
      })
    },

    toMyOrder() {
      this.$router.push('/user/order/list')
    },
    payFailed() {
      this.dialogVisible = false
      this.$router.push({ name: 'order-pay-failed', params: { orderNumber: this.orderNumber }})
    },
    paySuccess() {
      this.dialogVisible = false
      this.$router.push({ name: 'order-pay-success', params: { orderNumber: this.orderNumber }})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';
.order-form {
  .el-form-item {
    margin-bottom: 0px;
  }
  /deep/ .el-form-item__label, /deep/ .el-form-item__content {
    line-height: 30px;
  }
  /deep/ label {
      font-weight: 700;
    }
  .view-order-detail {
    margin-left: 10px;
  }
  .order-amount {
    font-size: 16px;
    font-weight: bold;
    color: #F60;
  }
}
.pay-channel {
  display: inline-block;
  height: 90px;
  margin-right: 20px;
  text-align: center;
  cursor: pointer;
  img {
    height: 40px;
    padding: 10px;
    border: 1px solid #ccc;
  }
}
.pay-channel.selected {
  img {
    border: 1px solid $base-red;
  }
}
.pay-channel-title {
  text-align: center;
  margin:1px auto 0 auto;
  font-size: 14px;
  font-weight: 700;
  line-height: 26px;
}
.button-line {
  margin: 20px 20px;
}
.pay-channel-tips {
  text-align: center;
  font-size: 10px;
  color: red;
  font-weight: 500;
  line-height: 16px;
}

</style>
